export type UserAccessLogEntry = {
  id: string;
  createdAt: string;
  performedBy: string | null;
  action: string;
  targetEmail: string;
  oldValue: string | null;
  newValue: string | null;
  reason: string | null;
  note: string | null;
};

export const REVOCATION_REASONS = [
  'Advisor offboarded',
  'Admin no longer supporting firm',
  'Security concern',
  'Other',
];

const join = (...parts: (string | null | undefined | false)[]) => parts.filter(Boolean).join(' · ');

export const describeLogEntry = (entry: UserAccessLogEntry): { action: string; details: string } => {
  const ticket = entry.note ? `Ticket/comment: ${entry.note}` : null;
  switch (entry.action) {
    case 'Added':
      return { action: 'Added', details: join(entry.newValue, ticket) };
    case 'AccessTypeChanged':
      return { action: 'Changed access type', details: join(`${entry.oldValue} → ${entry.newValue}`, ticket) };
    case 'Revoked':
      return { action: 'Removed', details: join(entry.oldValue, entry.reason && `Reason: ${entry.reason}`, ticket) };
    case 'WelcomeEmailSent':
      return { action: 'Sent welcome email', details: '' };
    default:
      return { action: entry.action, details: '' };
  }
};
